import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import TravelReasonRepository from '@/shared/http/repositories/configuration/travelreason.js'
import TravelReasonModel from '@/shared/models/configuration/travelreason.js'
import TravelReasonForms from './travelreason-form'

export default {
  name: 'TravelReason',
  mixins: [ActionsForm],
  data () {
    return {
      data: TravelReasonModel,
      form: TravelReasonForms,
      contas: null
    }
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.descricao.maxlength)
    }
  },
  methods: {
    onLoad () {
      loading.push()
      TravelReasonRepository.GetAllPaging(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onCreate () {
      loading.push()
      this.data.empresaID = this.CompanySelected
      TravelReasonRepository.Create(this.data)
        .then(this.onResult)
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.empresaID = this.CompanySelected
      this.data.status = parseInt(this.data.status)
      TravelReasonRepository.Update(this.data)
        .then(this.onResult)
        .catch(this.onException)
    },
    onDelete (obj) {
      loading.push()
      TravelReasonRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onChangeFrequency (value) {
      if (value === false) {
        this.form.periodicidadeDias.value = 0
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/travelreason/travelreason.js